import { Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect } from 'react-router-dom';
import Home from './pages/Home';
import SignIn from './pages/auth/SignIn';
import AdminSignIn from './pages/auth/AdminSignin';
import ForgetPassword from './pages/auth/ForgetPassword';
import ResetPassword from './pages/auth/ResetPassword';
import ChangePassword from './pages/auth/ChangePassword';
import CreateAccount from './pages/auth/CreateAccount';
import UserManage from './pages/auth/UserManage';
import UserEdit from './pages/auth/UserEdit';
import MyAccount from './pages/myAccount/index';
import Tenants from './pages/tenants/index';
import Monthly21 from './pages/monthly/2_1';
import Monthly21a from './pages/monthly/2_1a';
import Quaterly22a from './pages/quaterly/2_2a';
import Quaterly22b from './pages/quaterly/2_2b';
import Quaterly25 from './pages/quaterly/2_5';
import SemiAnnual14 from './pages/semi_annual/1_4';
import SemiAnnual26 from './pages/semi_annual/2_6';
import Annual32 from './pages/annual/3_2';
import Annual73 from './pages/annual/7_3';
import ExportMonthly from './pages/pdfExport/monthly';
import ExportQuaterly from './pages/pdfExport/quaterly';
import ExportSemiAnnually from './pages/pdfExport/semi-annually';
import ExportAnnually from './pages/pdfExport/annually';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

setupIonicReact();

const App: React.FC = () => (
  <IonApp>
    <IonReactRouter>
      <IonRouterOutlet>
        <Route exact path="/">
          <Home />
        </Route>        
        <Route exact path="/signin">
          <SignIn />
        </Route>
        <Route exact path="/adminsignin">
          <AdminSignIn />
        </Route>
        <Route exact path="/myaccount">
          <MyAccount />
        </Route>
        <Route exact path="/forgetpassword">
          <ForgetPassword />
        </Route>        
        <Route exact path="/changepassword">
          <ChangePassword />
        </Route>        
        <Route exact path="/resetpassword">
          <ResetPassword />
        </Route>
        <Route exact path="/usermanage">
          <Redirect to="/usermanage/1" />
        </Route>
        <Route exact path="/usermanage/:index">
          <UserManage />
        </Route>
        <Route exact path="/user/:id">
          <UserEdit />
        </Route>
        <Route exact path="/createuser">
          <CreateAccount />
        </Route>
        <Route exact path="/tenants">
          <Tenants />
        </Route>
        <Route exact path="/Monthly/2.1">
          <Monthly21 />
        </Route>
        <Route exact path="/Monthly/2.1a">
          <Monthly21a />
        </Route>
        <Route exact path="/Quaterly/2.2a">
          <Quaterly22a />
        </Route>
        <Route exact path="/Quaterly/2.2b">
          <Quaterly22b />
        </Route>
        <Route exact path="/Quaterly/2.5">
          <Quaterly25 />
        </Route>
        <Route exact path="/Semi-Annually/1.4">
          <SemiAnnual14 />
        </Route>
        <Route exact path="/Semi-Annually/2.6">
          <SemiAnnual26 />
        </Route>
        <Route exact path="/Annually/3.2">
          <Annual32 />
        </Route>
        <Route exact path="/Annually/7.3">
          <Annual73 />
        </Route>
        <Route exact path="/Export/Monthly">
          <ExportMonthly />
        </Route>
        <Route exact path="/Export/Quaterly">
          <ExportQuaterly />
        </Route>
        <Route exact path="/Export/Semi-Annually">
          <ExportSemiAnnually />
        </Route>
        <Route exact path="/Export/Annually">
          <ExportAnnually />
        </Route>
      </IonRouterOutlet>
    </IonReactRouter>
  </IonApp>
);

export default App;
